import { assign } from 'xstate5';

import { type ReorderMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const setReordering: ReorderMachineAction<{ reordering: boolean }> = assign(
  (_args, params) => ({
    reordering: params.reordering,
  }),
);
